export const categoryLabels = {
  adult: 'Adult',
  senior: 'Senior',
  youth: 'Youth',
  child: 'Child (under 12)'
};

export const billingCycleLabels = {
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  annually: 'Annually'
};
